import styled from "styled-components";

const Container = styled.button`
  font-family: KBFGDisplayM;
  border: none;
  padding: ${(props) => props.p || "0.5em 0.5em 0.25em 0.5em"};
  margin: ${(props) => props.m || "0"};
  border-radius: 50%;
  height: ${(props) => props.height || "null"};
  width: ${(props) => props.width || "null"};
  display: inline-flex;
  font-size: 1.25em;
  &:hover {
    opacity: 0.7;
  }
  &:active {
    opacity: 0.8;
  }
`;

export default Container;
